import actions from './actions'
import mutations from './mutations'
import { mergeDeep } from '../../utils/helpers'

const initState = () => ({
    reports: [],
    sum: null,
    filters: {
        fromDate: null,
        toDate: null
    },
    pagination: {
        page: 1,
        length: null,
        total: null
    },
    isLoaded: false
})

const report = {
    namespaced: true,
    state: {
        business: {
            dateGroup: initState()
        },
        leader: {
            businessGroup: initState()
        },
        admin: {
            leaderGroup: initState(),
            businessGroup: mergeDeep(initState(), {
                filters: {
                    leader: null
                }
            }),
            dayGroup: initState()
        }
    },
    mutations,
    actions
}

export default report
